module.exports = __webpack_public_path__ + "static/media/William Large Headshot.1f57fc3d.jpeg";